
import React, { useState, useEffect } from "react";
import { BASE_URL } from "../../../constants";
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Row, Col, Container, Card, Button, InputGroup, OverlayTrigger, Tooltip } from 'react-bootstrap';
import '../../../CommonCSS/SocietyCSS.css';
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Disc_Lf_Date = () => {

//  const [isEditable, setIsEditable] = useState(false);
  const [ddlSection, setDdlSection] = useState([]);
  const [ddlAcademicYears, setDdlAcademicYears] = useState([]);
  const [errors, setErrors] = useState({});

  // Header State
  const [headerData, setHeaderData] = useState({
    section_id: '',
    year1: '',
    year2: '',

  });

  // Child Table Data
  const [childRows, setChildRows] = useState([
    {
      irn: '',
      inst_no: '',
      last_date: '',
      late_fee_amt: '',
      disc_amt: '',
    }
  ]);

  const SCREEN_STATE = {
    INITIAL: "INITIAL",
    NEW: "NEW",
    DETAILS: "DETAILS"
  };

const [screenState, setScreenState] = useState(SCREEN_STATE.INITIAL);

  useEffect(() => {
    fetchLists();
  }, []);

  const fetchLists = async () => {
    try {
  
      const sectionresult = await axios.get(`${BASE_URL}/api/ddl_sections`);
      setDdlSection(sectionresult.data);

      const year_result = await axios.get(`${BASE_URL}/api/ddl_years`);
      setDdlAcademicYears(year_result.data);


    } catch (err) {
      console.error("Dropdown fetch error:", err);
    }
  };
        
  const handleHeaderChange = (e) => {

    const { name, value } = e.target;
    setHeaderData(prev => ({ ...prev, [name]: value }));

    if (name === 'year1') {
      setHeaderData(prev => ({ ...prev, year2: Number(value) + 1 }));
    }

    setErrors(prev => ({
      ...prev,
      [name]: ""
    }));

  };

  const handleChildChange = (index, e) => {
    const { name, value } = e.target;
    const updatedRows = [...childRows];
    updatedRows[index][name] = value;
    setChildRows(updatedRows);
  };


  const addRow = () => {

//    const newIndex = childRows.length + 1; // 1-based index

    const newRow = {
      irn: '',
      inst_no: '',
      last_date: '',
      late_fee_amt: '',
      disc_amt: '',
    };
    setChildRows([...childRows, newRow]);
    //setChildRows([...childRows, { parent_irn: '', maintId: '', dispOrder: '', amount: '' }]);
  };

  const removeRow = (index) => {

    const updatedRows = [...childRows];
    updatedRows.splice(index, 1);
    setChildRows(updatedRows);

  };

  const handleNew = () => {

    resetPage();
    setScreenState(SCREEN_STATE.NEW);

  };

  const handleProceed = async () => {

    const newErrors = {};
    
    if (!headerData.section_id || headerData.section_id === '') {
      newErrors.section_id = 'Error';
      toast.error('Please select Section.');
    } else if (!headerData.year1 || headerData.year1 === '') {
      newErrors.year1 = 'Error';
      toast.error('Please select Academic Year.');
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      const firstErrorKey = Object.keys(newErrors)[0];
      if (firstErrorKey) {
        const el = document.getElementsByName(firstErrorKey)[0];
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "center" });
          el.focus(); // 🔥 bonus (cursor goes there)
        }
      }
      return;
    }

    const response = await axios.get(`${BASE_URL}/api/get_disc_late_fees`, { 
       params: { p_Year1: headerData.year1, p_Year2: headerData.year2,
                 p_Section_Id: headerData.section_id }});

    setChildRows(response.data);

    setScreenState(SCREEN_STATE.DETAILS);

  };

  const resetPage = () => {

    setHeaderData({
      section_id: '',
      year1: '',
      year2: '',
    });

    setChildRows([
      {
        irn: '',
        inst_no: '',
        last_date: '',
        late_fee_amt: '',
        disc_amt: '',
      }
    ]);
  };

  const handleSave = async () => {

    const isConfirmed = window.confirm("Sure you want to Save the record ?");

    if (!isConfirmed) return;

    const structdata = {
      header: headerData,
      details: childRows,
    };

    const response = await axios.post(`${BASE_URL}/api/save_disc_late_fees`, structdata);

    if (response.data.message === '1') {
      resetPage();
      setScreenState(SCREEN_STATE.INITIAL);
    }

  };

  const handleClear = () => {

    if (window.confirm("Clear all data?")) {
      resetPage();
      setScreenState(SCREEN_STATE.INITIAL);
    }

  };

  return (
    <Container fluid className="p-3">    
      <Card className="mb-4 p-3">
       
        {/* { */}
          <Row className="mb-1">
          
          <Col md={4}>
            <InputGroup>
              <InputGroup.Text style={{ width: "100px" }}>
                Section<span style={{ color: "red" }}>*</span>
              </InputGroup.Text>
              <select className={`form-select ${errors.section_id ? "is-invalid" : ""}`}
                name="section_id" value={headerData.section_id}
                disabled={screenState !== SCREEN_STATE.NEW}
                 onChange={(e) => handleHeaderChange(e)}
              >
                <option value="">-- Select Section --</option>
                <option value="0">All Sections</option>
                 {ddlSection.map(sec => (
                  <option key={sec.section_id} value={sec.section_id}>{sec.section_desc}</option>
                ))}
                
              </select>
            </InputGroup>
          </Col>

          <Col md={4}>

            <InputGroup>
              <InputGroup.Text style={{ width: "140px" }}>Academic Year<span style={{ color: "red" }}>*</span></InputGroup.Text>
              <select className={`form-select ${errors.year1 ? "is-invalid" : ""}`}
                name="year1" value={headerData.year1}
                onChange={handleHeaderChange} disabled={screenState !== SCREEN_STATE.NEW} >
                <option value="">--Select Year--</option>
                {ddlAcademicYears.map(y => (
                  <option key={y.year1} value={y.year1}>{y.disp_year}</option>
                ))}
              </select>

            </InputGroup>
          </Col>

          <Col md={2}>
            <button type="button" className="btn btn-warning" style={{ width: "135px" }}
              disabled={screenState !== SCREEN_STATE.NEW} onClick={handleProceed}  > Proceed </button>
          </Col>

        </Row>
        
        <Row className="mb-1">

          <Col>
            <div className="d-flex justify-content-end gap-2 mt-1 flex-wrap">

              <button type="button" className="btn btn-primary" style={{ width: "135px" }}
                onClick={handleNew} disabled={screenState !== SCREEN_STATE.INITIAL} >New </button>

              <button type="button" className="btn btn-secondary" style={{ width: "135px" }} disabled={screenState === SCREEN_STATE.INITIAL}
                onClick={handleClear}> Clear </button>

              <button type="button" className="btn btn-success" style={{ width: "135px" }}
                onClick={handleSave} disabled={screenState !== SCREEN_STATE.DETAILS} > Save </button>

            </div>
          </Col>
        </Row>

      </Card>

      {/* Child Table */}
      <Card className="p-3">
        <div style={{ minHeight: '220px' }} className="table-wrapper">
          <table style={{ maxHeight: '35px' }} className="responsive-table scty-custom-table">
            <thead>
              <tr>
                <th style={{ width: '4%', textAlign: 'center' }}>#</th>
                <th style={{ width: '35%', textAlign: 'left' }}>Installment</th>
                <th style={{ width: '16%', textAlign: 'left' }}>Installment Last Date </th>
                <th style={{ width: '16%', textAlign: 'right' }}>Late Fee Amt </th>
                <th style={{ width: '15%', textAlign: 'right' }}>Discount Amount</th>
                {/* If needed, uncomments. 
                <th style={{ width: '6%', textAlign: 'right' }}></th> */}
              </tr>
            </thead>
    
            <tbody>
              {childRows.map((row, index) => (
                <tr key={index}>
                  
                  <td style={{ width: "5%", textAlign: 'center' }}>{index + 1}</td>

                  <td>
                    <select className="form-select" disabled={screenState !== SCREEN_STATE.DETAILS}
                      name="inst_no" value={row.inst_no} onChange={(e) => handleChildChange(index, e)}>
                      <option value="0">Select Installment</option>
                      <option value="1">1st Installment</option>
                      <option value="2">2nd Installment</option>
                      <option value="3">3rd Installment</option>
                      <option value="4">4th Installment</option>
                      <option value="5">5th Installment</option>
                      <option value="6">6th Installment</option>
                    </select>
                  </td>

                  <td>
                    <input style={{ textAlign: 'left' }} disabled={screenState !== SCREEN_STATE.DETAILS}
                      type="date" className="form-control" name="last_date" value={row.last_date} 
                      onChange={(e) => handleChildChange(index, e)} />
                  </td>

                  <td>
                    <input style={{ textAlign: 'right' }} disabled={screenState !== SCREEN_STATE.DETAILS}
                      type="number" className="form-control" name="late_fee_amt" value={row.late_fee_amt} 
                      onChange={(e) => handleChildChange(index, e)} />
                  </td>
                  
                  <td>
                    <input style={{ textAlign: 'right' }} disabled={screenState !== SCREEN_STATE.DETAILS}
                      type="number" className="form-control" name="disc_amt" value={row.disc_amt} 
                      onChange={(e) => handleChildChange(index, e)} />
                  </td>
                                    
                  {/* If needed, uncomments. 
                  <td style={{ textAlign: 'center' }}>
                    {childRows.length > 1 && (
                      <Button variant="danger" onClick={() => removeRow(index)} size="sm">Delete</Button>
                    )}
                  </td> */}
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* If needed, uncomments.
         <div className="d-flex justify-content-end mt-2">
          <OverlayTrigger placement="bottom"
            overlay={<Tooltip id="add-tooltip" style={{ backgroundColor: "#e9ecef" }}>Add Row</Tooltip>}>
            <Button variant="primary" onClick={addRow}
               disabled={screenState !== SCREEN_STATE.DETAILS}
              style={{ width: "45px", height: "45px", borderRadius: "50%", padding: "0", fontSize: "30px" }}> +
            </Button>
          </OverlayTrigger>
        </div> */}

      </Card>

      {/* Buttons */}
    </Container>
  );
};

export default Disc_Lf_Date;
